"use client";

import { useSyncExternalStore } from "react";

export default function useStudioClientReady() {
  return useSyncExternalStore(
    (listener) => {
      const timeoutId = window.setTimeout(listener, 0);

      return () => {
        window.clearTimeout(timeoutId);
      };
    },
    () => true,
    () => false,
  );
}
